import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TarActionItemCode } from '@ekhodealer/ekho-common';

import type { GeneratePlateResponse } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

import { updateProgressCache } from './progressCacheUtils';


export interface GeneratePlateInput {
	registrationReceipt: {
		base64Data: string;
		type?: string;
		name?: string;
	};
}

export const generatePlate = async (
	servicesProviderId: string,
	orderId: string,
	data: GeneratePlateInput,
): Promise<GeneratePlateResponse> => {
	const response = await apiClient.post<GeneratePlateResponse>(
		ordersEndpoints.generatePlate(servicesProviderId, orderId),
		data,
	);
	return response.data;
};

export const useGeneratePlate = (orderId: string | undefined) => {
	const servicesProviderId = useCurrentServicesProviderId();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (input: GeneratePlateInput) => {
			if (!orderId || !servicesProviderId) {
				throw new Error(
					'Unable to generate plate without an order ID or services provider ID.',
				);
			}

			return generatePlate(servicesProviderId, orderId, input);
		},
		onSuccess: (data) => {
			if (!orderId || !servicesProviderId) return;
			updateProgressCache(queryClient, servicesProviderId, orderId, data.progress, TarActionItemCode.GENERATE_PLATE);
		},
	});
};
